import './SystemMessages.scss';

export { default } from './SystemMessages';
